import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * ラジオオフアイコン
 */
const RadioOffIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g fill={CLIENT_SETTINGS.colors.contentBackground}>
          <path
            d="M 12 23 C 9.061790466308594 23 6.299449920654297 21.85580062866211 4.221819877624512 19.77817916870117 C 2.144200086593628 17.7005500793457 1 14.93820953369141 1 12 C 1 9.061790466308594 2.144200086593628 6.299449920654297 4.221819877624512 4.221819877624512 C 6.299449920654297 2.144200086593628 9.061790466308594 1 12 1 C 14.93820953369141 1 17.7005500793457 2.144200086593628 19.77817916870117 4.221819877624512 C 21.85580062866211 6.299449920654297 23 9.061790466308594 23 12 C 23 14.93820953369141 21.85580062866211 17.7005500793457 19.77817916870117 19.77817916870117 C 17.7005500793457 21.85580062866211 14.93820953369141 23 12 23 Z"
            stroke="none"
          />
          <path
            d="M 12 2 C 6.485979080200195 2 2 6.485979080200195 2 12 C 2 17.51401901245117 6.485979080200195 22 12 22 C 17.51401901245117 22 22 17.51401901245117 22 12 C 22 6.485979080200195 17.51401901245117 2 12 2 M 12 0 C 18.62742042541504 0 24 5.372579574584961 24 12 C 24 18.62742042541504 18.62742042541504 24 12 24 C 5.372579574584961 24 0 18.62742042541504 0 12 C 0 5.372579574584961 5.372579574584961 0 12 0 Z"
            stroke="none"
            fill={CLIENT_SETTINGS.colors.background}
          />
        </g>
      </svg>
    </Icon>
  )
}

export default RadioOffIcon
